import { Image as ImageIcon, BookOpen, Presentation, Layers } from 'lucide-react';

export default function Deliverables() {
  const items = [
    {
      icon: <Layers className="w-10 h-10 text-primary-600 dark:text-primary-500 mb-6 group-hover:scale-110 group-hover:-rotate-3 transition-transform duration-500 drop-shadow-[0_0_10px_rgba(224,0,0,0.3)] dark:drop-shadow-[0_0_15px_rgba(224,0,0,0.5)]" />,
      title: "شعار مبني على منطق (Concept Driven)",
      desc: "تصميم مدروس وذو معنى عميق يخدم العلامة التجارية."
    },
    {
      icon: <Presentation className="w-10 h-10 text-primary-600 dark:text-primary-500 mb-6 group-hover:scale-110 group-hover:rotate-3 transition-transform duration-500 drop-shadow-[0_0_10px_rgba(224,0,0,0.3)] dark:drop-shadow-[0_0_15px_rgba(224,0,0,0.5)]" />,
      title: "نظام بصري متكامل",
      desc: "ألوان استراتيجية ومجموعة خطوط وعناصر تتنفس بمرونة."
    },
    {
      icon: <ImageIcon className="w-10 h-10 text-primary-600 dark:text-primary-500 mb-6 group-hover:scale-110 transition-transform duration-500 drop-shadow-[0_0_10px_rgba(224,0,0,0.3)] dark:drop-shadow-[0_0_15px_rgba(224,0,0,0.5)]" />,
      title: "تطبيقات وموكابس (Mockups)",
      desc: "تغليف وعروض احترافية عالية الجودة تميزك في محفظة الأعمال."
    },
    {
      icon: <BookOpen className="w-10 h-10 text-primary-600 dark:text-primary-500 mb-6 group-hover:scale-110 transition-transform duration-500 drop-shadow-[0_0_10px_rgba(224,0,0,0.3)] dark:drop-shadow-[0_0_15px_rgba(224,0,0,0.5)]" />,
      title: "دليل الهوية البصرية (Brand Guidelines)",
      desc: "ملف احترافي يشرح قواعد استخدام الهوية لتقديمه للعميل."
    }
  ];

  return (
    <section className="py-32 relative bg-white dark:bg-zinc-950 transition-colors duration-500">
      <div className="container mx-auto px-4 z-10 relative">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-lg font-bold text-primary-600 dark:text-primary-500 mb-3 uppercase tracking-widest inline-flex items-center gap-2 transition-colors duration-500">
            <span className="w-8 h-1 bg-primary-500 rounded-full"></span>
            مخرجات الدورة
            <span className="w-8 h-1 bg-primary-500 rounded-full"></span>
          </h2>
          <h3 className="text-4xl md:text-5xl font-extrabold text-slate-900 dark:text-white mb-6 leading-[1.3] drop-shadow-sm dark:drop-shadow-lg transition-colors duration-500">
            مخرجات ستفخر بها في <span className="text-transparent bg-clip-text bg-gradient-to-l from-primary-600 via-primary-500 to-primary-700 dark:from-primary-400 dark:via-primary-500 dark:to-primary-600">بورتفوليو أعمالك</span>
          </h3>
          <p className="text-xl text-slate-600 dark:text-zinc-400 leading-relaxed font-light transition-colors duration-500">
            بنهاية الدورة، ستمتلك مشروعاً متكاملاً جاهزاً للإضافة في معرض أعمالك، مما سيزيد من فرصتك للحصول على عملاء حقيقيين.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {items.map((item, idx) => (
            <div key={idx} className="bg-slate-50 dark:bg-zinc-900/50 backdrop-blur-xl border border-slate-200 dark:border-white/5 rounded-lg p-10 hover:border-primary-500/30 dark:hover:border-primary-500/50 hover:bg-white dark:hover:bg-zinc-800/80 hover:-translate-y-4 transition-all duration-500 relative group overflow-hidden cursor-default shadow-md hover:shadow-xl dark:shadow-2xl">
              {/* Glow Effect */}
              <div className="absolute top-0 right-0 w-48 h-48 bg-primary-500/5 dark:bg-primary-500/10 rounded-full -mr-24 -mt-24 group-hover:bg-primary-500/10 dark:group-hover:bg-primary-500/20 group-hover:scale-150 transition-all duration-700 ease-out blur-[40px] pointer-events-none"></div>

              <div className="relative z-10">
                <div className="inline-flex items-center justify-center p-4 rounded-2xl bg-white dark:bg-white/5 border border-slate-100 dark:border-white/10 mb-8 shadow-sm dark:shadow-inner group-hover:bg-slate-50 dark:group-hover:bg-white/10 transition-colors duration-300">
                  {item.icon}
                </div>
                <h4 className="text-2xl font-bold text-slate-900 dark:text-white mb-4 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors duration-500">{item.title}</h4>
                <p className="text-slate-600 dark:text-zinc-400 leading-relaxed text-lg transition-colors duration-500">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
